/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconDeviceDesktopMinus = createReactComponent(
  "device-desktop-minus",
  "IconDeviceDesktopMinus",
  [
    [
      "path",
      {
        d: "M13.5 16h-9.5a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v10",
        key: "svg-0"
      }
    ],
    ["path", { d: "M7 20h5", key: "svg-1" }],
    ["path", { d: "M9 16v4", key: "svg-2" }],
    ["path", { d: "M16 19h6", key: "svg-3" }]
  ]
);

export { IconDeviceDesktopMinus as default };
//# sourceMappingURL=IconDeviceDesktopMinus.js.map
